export const de = {
  // App branding
  appName: 'Hekaya',

  // Navigation
  home: 'Startseite',
  forYou: 'Für dich',
  myList: 'Meine Liste',
  profile: 'Profil',
  userProfile: 'Benutzerprofil',

  // Authentication
  signIn: 'Anmelden',
  signUp: 'Registrieren',
  signOut: 'Abmelden',
  signInWithApple: 'Mit Apple anmelden',
  signUpWithApple: 'Mit Apple registrieren',
  signInWithGoogle: 'Mit Google anmelden',
  signUpWithGoogle: 'Mit Google registrieren',
  appleSignInFailed: 'Apple-Anmeldung fehlgeschlagen. Bitte erneut versuchen.',
  appleAuthExpired: 'Apple-Code abgelaufen',
  appleAuthRetrying: 'Automatischer Wiederholungsversuch...',
  appleAuthRetryFailed: 'Apple-Anmeldung fehlgeschlagen. Bitte erneut versuchen.',
  appleAuthMaxRetriesReached: 'Zu viele Versuche. Bitte später erneut versuchen.',
  appleSignInCancelled: 'Apple-Anmeldung wurde abgebrochen.',
  appleAccountAlreadyExists: 'Ein Konto mit dieser Apple-ID existiert bereits. Bitte melden Sie sich stattdessen an.',
  appleAccountNotFound: 'Kein Konto mit dieser Apple-ID gefunden. Bitte zuerst registrieren.',
  googleSignInFailed: 'Google-Anmeldung fehlgeschlagen. Bitte erneut versuchen.',
  googleAuthRetrying: 'Automatischer Wiederholungsversuch...',
  googleAuthMaxRetriesReached: 'Zu viele Versuche. Bitte später erneut versuchen.',
  or: 'oder',
  email: 'E-Mail',
  emailOrPhone: 'E-Mail oder Telefon',
  enterEmail: 'E-Mail eingeben',
  enterEmailOrPhone: 'E-Mail oder Telefonnummer eingeben',
  emailOrPhonePlaceholder: 'email@beispiel.de oder +491234567890',
  signInRequired: 'Anmeldung erforderlich',
  toWatchThisEpisode: 'Um diese Folge anzusehen',
  toAddEpisodeToFavorites: 'Um diese Folge zu Favoriten hinzuzufügen',
  pleaseSignInToWatch: 'Bitte melden Sie sich an, um diese Folge anzusehen',
  pleaseSignInToAddFavorite: 'Bitte melden Sie sich an, um diese Folge zu Favoriten hinzuzufügen',
  pleaseSignInToAddSerieFavorite: 'Bitte melden Sie sich an, um diese Serie zu Favoriten hinzuzufügen',
  pleaseSignInToSubscribe: 'Bitte melden Sie sich an, um zu abonnieren',
  pleaseSignInToAccessRewards: 'Bitte melden Sie sich an, um auf alle Funktionen zuzugreifen und Ihre Belohnungen zu verfolgen.',
  subscriptionRequired: 'Abonnement erforderlich',
  episodeRequiresPremium: 'Diese Folge erfordert ein Premium-Abonnement',

  // Force update
  updateRequired: 'Aktualisierung erforderlich',
  currentVersion: 'Aktuelle Version',
  requiredVersion: 'Erforderliche Version',
  updateNow: 'Jetzt aktualisieren',
  appCannotBeUsedWithoutUpdate: 'Die App kann ohne Aktualisierung nicht verwendet werden',
  forceUpdateDefaultMessage: 'Eine neue Version der App ist verfügbar. Bitte aktualisieren Sie, um die App weiterhin zu verwenden.',

  // Recommended update
  updateAvailable: 'Update verfügbar',
  recommendedVersion: 'Empfohlene Version',
  updateButton: 'Aktualisieren',
  laterButton: 'Später',
  updateWillBeShownAgainIn24Hours: 'Dieses Update wird in 24 Stunden erneut angezeigt',
  recommendedUpdateMessage: 'Eine neue Version der App mit Verbesserungen und neuen Funktionen ist verfügbar. Wir empfehlen die Aktualisierung für die beste Erfahrung.',

  // Errors
  error: 'Fehler',
  pleaseFillAllFields: 'Bitte füllen Sie alle Felder aus',
  failedToCreateAccount: 'Konto konnte nicht erstellt werden',
  invalidCredentials: 'Ungültige Zugangsdaten',
  accountDisabled: 'Dieses Konto wurde deaktiviert',
  emailAlreadyExists: 'Diese E-Mail-Adresse wird bereits von einem anderen Konto verwendet',
  phoneAlreadyExists: 'Diese Telefonnummer wird bereits von einem anderen Konto verwendet',
  invalidEmailFormat: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  invalidPhoneFormat: 'Bitte geben Sie eine gültige Telefonnummer ein',
  accountMergeNotSupported: 'Es existiert bereits ein Konto mit dieser E-Mail-Adresse. Bitte melden Sie sich mit Ihrer ursprünglichen Anmeldemethode an.',

  // Content
  searchDramas: 'Dramen suchen...',
  noResultsFound: 'Keine Ergebnisse gefunden für „{query}“',
  searchResultsOne: '1 Ergebnis für „{query}“',
  searchResultsMany: '{count} Ergebnisse für „{query}“',
  allSeries: 'Alle Serien',
  topCharts: 'Top-Charts',
  recommendedForYou: 'Für dich empfohlen',
  basedOnPreferences: 'Basierend auf deinen Vorlieben',
  continueWatching: 'Weiterschauen',
  resumeWatching: 'Weiterschauen',
  similarToWatched: 'Ähnlich wie das, was du gesehen hast',
  trendingSearches: 'Trend-Suchen',
  noSeriesInProgress: 'Keine laufenden Serien',
  startWatchingToSee: 'Beginnen Sie eine Serie anzusehen, um sie hier zu sehen',
  noContentAvailable: 'Keine Inhalte verfügbar',
  checkSupabaseConfig: 'Bitte überprüfen Sie Ihre Supabase-Konfiguration',

  // Series and episodes
  seasons: 'Staffeln',
  season: 'Staffel',
  episodes: 'Folgen',
  synopsis: 'Zusammenfassung',
  episode: 'Folge',
  play: 'Abspielen',
  swipeToSeeMore: 'Wischen, um mehr zu sehen',
  myListAction: 'Meine Liste',
  addToMyList: 'Zu Favoriten hinzufügen',
  removeFromMyList: 'Aus Favoriten entfernen',
  popular: 'Beliebt',
  new: 'Neu',
  trending: 'Im Trend',
  highlight: 'Highlight',
  free: 'Kostenlos',
  premium: 'Premium',
  premiumEpisode: 'Premium-Folge',
  signInToUnlock: 'Anmelden zum Freischalten',
  subscribeToWatch: 'Abonnieren zum Ansehen',

  // Profile
  subscribeToPremium: 'Auf Premium upgraden',
  subscribeWithDCB: 'Mit DCB auf Premium upgraden',
  dcbSubscribeModalTitle: 'Abonnement per Mobilzahlung',
  dcbSubscribeLoading: 'Zahlung wird vorbereitet...',
  dcbSubscribeError: 'Die Zahlungsseite konnte nicht geladen werden.',
  dcbSubscribeRetry: 'Erneut versuchen',
  restorePurchases: 'Käufe wiederherstellen',
  purchaseProcessing: 'Verarbeitung...',
  subscriptionActivated: 'Abonnement erfolgreich aktiviert!',
  webPaymentUnavailable: 'Web-Zahlungen sind derzeit nicht verfügbar. Bitte später erneut versuchen.',
  paymentInitializing: 'Zahlungssystem wird initialisiert. Bitte in wenigen Sekunden erneut versuchen.',
  loadingOffers: 'Angebote werden geladen...',
  purchasesRestored: 'Ihr Abonnement wurde erfolgreich wiederhergestellt! Sie haben jetzt Zugriff auf alle Premium-Inhalte.',
  noPurchasesToRestore: 'Keine aktiven Abonnements zum Wiederherstellen gefunden. Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an den Support.',
  purchaseFailed: 'Kauf fehlgeschlagen. Bitte erneut versuchen.',
  restoreFailed: 'Wiederherstellung der Käufe fehlgeschlagen.',
  restoreNetworkError: 'Verbindungsproblem. Bitte überprüfe deine Internetverbindung und versuche es erneut.',
  restoreReceiptInUse: 'Dieses Store-Konto ist bereits mit einem anderen Profil verknüpft. Melde dich mit dem ursprünglichen Konto an, um dieses Abo zu nutzen.',
  noActiveSubscription: 'Kein aktives Abonnement zum Wiederherstellen gefunden.',
  iapNotAvailable: 'In-App-Käufe sind nicht verfügbar.',
  webPurchaseNotSupported: 'In-App-Käufe sind im Web nicht verfügbar. Bitte verwenden Sie die mobile App.',

  // Premium subscription paywall
  premiumSubscriptionTitle: 'Premium Monatsabonnement',
  premiumSubscriptionTagline: 'Schalten Sie unbegrenzten Zugriff auf alle Dramaserien und Folgen frei',
  whatYouGet: 'Was Sie erhalten',

  // Profile subscription information
  profileSubscriptionDescription: 'Erhalten Sie mit unserem Monatsabonnement unbegrenzten Zugriff auf alle Dramaserien und Folgen.',
  profileBenefit1: 'Sehen Sie jede Folge aus unserer gesamten Bibliothek',
  profileBenefit2: 'Sofortiger Zugriff auf alle neuen Folgen',
  profileBenefit3: 'Werbefreies Seherlebnis',

  premiumBenefit1: 'Unbegrenzter Zugriff auf alle Dramaserien - jede Folge, jederzeit',
  premiumBenefit2: 'Vollständige Bibliothek aktueller Inhalte mit hunderten Folgen',
  premiumBenefit3: 'Sofortiger Zugriff auf alle neuen Folgen direkt nach Veröffentlichung',
  premiumBenefit4: 'Jede Folge ohne Einschränkungen oder Limits ansehen',
  premiumBenefit5: 'Werbefreies Seherlebnis für ununterbrochene Unterhaltung',
  premiumBenefit6: 'Hochwertiges Video-Streaming für das beste Seherlebnis',
  premiumBenefit7: 'Zugriff auf allen Ihren Geräten - Telefon, Tablet und Web',
  bestValue: 'Bestes Angebot',
  subscriptionIncludes: 'Vollständiger Zugriff auf alle Inhalte',
  perMonth: '/Monat',
  perWeek: '/Woche',
  startSubscription: 'Abonnement starten',
  learnMoreAboutSubscription: 'Mehr über das Abonnement erfahren',

  // Subscription terms
  subscriptionTerms: 'Die Abrechnung erfolgt über Ihr Konto zum auf dem Abonnementbildschirm angegebenen Preis. Das Abonnement verlängert sich automatisch monatlich, sofern Sie es nicht mindestens 24 Stunden vor dem Verlängerungsdatum kündigen. Die Abbuchung erfolgt 24 Stunden vor Ende Ihres aktuellen Abrechnungszeitraums.',

  // Subscription details modal
  subscriptionDetails: 'Abonnement-Details',
  whatIsIncluded: 'Was ist enthalten',
  subscriptionDetailsDescription: 'Ihr Premium-Monatsabonnement gewährt Ihnen unbegrenzten Zugriff auf alle Dramaserien und Folgen in unserer Bibliothek. Dies umfasst alle aktuellen Inhalte sowie alle neuen Folgen, die während Ihres Abonnementzeitraums veröffentlicht werden. Sie können jede Folge jederzeit auf einem beliebigen Gerät ohne Einschränkungen ansehen.',
  howBillingWorks: 'Wie die Abrechnung funktioniert',
  billingDescription: 'Die Abrechnung erfolgt über Ihr Konto zum auf dem Abonnementbildschirm angegebenen Preis. Das Abonnement verlängert sich automatisch jeden Monat, sofern Sie es nicht mindestens 24 Stunden vor dem Verlängerungsdatum kündigen. Die Abbuchung erfolgt 24 Stunden vor Ende Ihres aktuellen Abrechnungszeitraums.',
  howToCancel: 'So kündigen Sie',
  cancellationDescription: 'Sie können Ihr Abonnement jederzeit in den Einstellungen Ihres Geräts kündigen. Für iOS: Einstellungen > [Ihr Name] > Abonnements. Für Android: Google Play Store > Menü > Abonnements. Wählen Sie diese App und tippen Sie auf „Abonnement kündigen“. Ihr Abonnement bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv.',
  cancellationDescriptionIos: 'Sie können Ihr Abonnement jederzeit in den Einstellungen Ihres Geräts kündigen. Für iOS: Einstellungen > [Ihr Name] > Abonnements. Wählen Sie diese App und tippen Sie auf „Abonnement kündigen“. Ihr Abonnement bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv.',
  cancellationDescriptionAndroid: 'Sie können Ihr Abonnement jederzeit in den Einstellungen Ihres Geräts kündigen. Für Android: Google Play Store > Menü > Abonnements. Wählen Sie diese App und tippen Sie auf „Abonnement kündigen“. Ihr Abonnement bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv.',
  subscriptionExpiry: 'Was passiert, wenn das Abonnement abläuft',
  expiryDescription: 'Wenn Sie kündigen oder Ihr Abonnement abläuft, verlieren Sie den Zugriff auf Premium-Inhalte. Ihr Verlauf und Ihre Favoriten werden jedoch gespeichert. Sie können jederzeit wieder abonnieren, um den vollen Zugriff auf alle Premium-Folgen zurückzuerhalten.',
  deviceCompatibility: 'Gerätekompatibilität',
  compatibilityDescription: 'Ihr Abonnement funktioniert auf allen Plattformen, auf denen Sie dasselbe Konto verwenden. Melden Sie sich auf jedem Gerät mit demselben Konto an, um auf Ihre Premium-Vorteile zuzugreifen.',
  helpFeedback: 'Hilfe & Feedback',
  language: 'Sprache',
  notifications: 'Benachrichtigungen',
  notificationSettings: 'Benachrichtigungseinstellungen',
  pushNotifications: 'Push-Benachrichtigungen',
  enabled: 'Aktiviert',
  disabled: 'Deaktiviert',
  enable: 'Aktivieren',
  enabling: 'Wird aktiviert...',
  pushNotificationsEnabled: 'Push-Benachrichtigungen erfolgreich aktiviert',
  pushNotificationsDisabled: 'Push-Benachrichtigungen deaktiviert',
  enablePushNotificationsInSettings: 'Um Benachrichtigungen zu erhalten, aktivieren Sie diese bitte in den Geräteeinstellungen.',
  openSettings: 'Einstellungen öffnen',
  pushNotificationsEnabledDescription: 'Sie erhalten Benachrichtigungen auf diesem Gerät',
  pushNotificationsDisabledDescription: 'Aktivieren Sie Benachrichtigungen, um auf dem Laufenden zu bleiben',
  notificationCategories: 'Benachrichtigungskategorien',
  notificationCategoriesDescription: 'Wählen Sie aus, welche Arten von Benachrichtigungen Sie erhalten möchten',
  newEpisodes: 'Neue Folgen',
  newEpisodesDescription: 'Werden Sie benachrichtigt, wenn neue Folgen veröffentlicht werden',
  recommendations: 'Empfehlungen',
  recommendationsDescription: 'Personalisierte Inhaltsvorschläge für Sie',
  subscriptionReminders: 'Abonnement-Erinnerungen',
  subscriptionRemindersDescription: 'Erinnerungen zu Ihrem Abonnementstatus',
  rewardsNotifications: 'Belohnungen & Erfolge',
  rewardsNotificationsDescription: 'Updates zu Ihren Belohnungen und Ihrem Fortschritt',
  marketingNotifications: 'Marketing & Aktionen',
  marketingNotificationsDescription: 'Sonderangebote und Werbeinhalte',
  failedToUpdatePreferences: 'Benachrichtigungseinstellungen konnten nicht aktualisiert werden',
  failedToRequestPermission: 'Benachrichtigungsberechtigung konnte nicht angefordert werden',
  signInToSavePreferences: 'Melden Sie sich an, um Ihre Benachrichtigungseinstellungen geräteübergreifend zu speichern',
  done: 'Fertig',
  contactUs: 'Kontakt',
  settings: 'Einstellungen',
  privacyPolicy: 'Datenschutzerklärung',
  privacySettings: 'Datenschutz & Einwilligung',
  cookieSettings: 'Meine Cookie-Einstellungen',
  localStorage: 'Lokaler Speicher',
  termsConditions: 'Allgemeine Geschäftsbedingungen',
  legalNotice: 'Impressum',
  pricingConditions: 'Preisbedingungen',
  unsubscribe: 'Abbestellen',
  unsubscribeInfo: 'Informationen zur Kündigung',
  loadingUnsubscribeInfo: 'Kündigungsinformationen werden geladen...',
  unsubscribeContentNotAvailable: 'Kündigungsinformationen sind derzeit nicht verfügbar.',
  dcbUnsubscribeButton: 'Mein Abonnement kündigen',
  dcbUnsubscribeConfirmTitle: 'Bestätigung',
  dcbUnsubscribeConfirmMessage: 'Möchten Sie Ihr Abonnement wirklich kündigen? Sie verlieren den Zugriff auf Premium-Inhalte.',
  dcbUnsubscribeSuccess: 'Ihr Abonnement wurde erfolgreich gekündigt. Sie sind nicht mehr abonniert.',
  dcbUnsubscribeError: 'Ihr Abonnement konnte nicht gekündigt werden. Bitte wenden Sie sich an den Kundensupport.',
  loadingPrivacyPolicy: 'Datenschutzerklärung wird geladen...',
  privacyPolicyNotAvailable: 'Die Datenschutzerklärung ist derzeit nicht verfügbar.',
  loadingTermsConditions: 'Allgemeine Geschäftsbedingungen werden geladen...',
  termsConditionsNotAvailable: 'Die Allgemeinen Geschäftsbedingungen sind derzeit nicht verfügbar.',
  cookies: 'Cookies',
  cookiesSection: 'Cookies',
  legalSection: 'Rechtliche Informationen',
  loadingCookies: 'Cookie-Informationen werden geladen...',
  cookiesNotAvailable: 'Cookie-Informationen sind derzeit nicht verfügbar.',
  loadingLegalNotice: 'Impressum wird geladen...',
  legalNoticeNotAvailable: 'Das Impressum ist derzeit nicht verfügbar.',
  loadingPricingConditions: 'Preisbedingungen werden geladen...',
  pricingConditionsNotAvailable: 'Preisbedingungen sind derzeit nicht verfügbar.',
  retry: 'Erneut versuchen',
  noEmailApp: 'Auf diesem Gerät ist keine E-Mail-Anwendung verfügbar.',
  errorOpeningEmail: 'E-Mail-Anwendung kann nicht geöffnet werden.',
  errorOpeningSettings: 'Systemeinstellungen können nicht geöffnet werden.',
  security: 'Sicherheit',

  // Loading and errors
  loading: 'Wird geladen...',
  loadingContent: 'Inhalt wird geladen...',
  preparingVideo: 'Video wird vorbereitet...',

  seasonNotFound: 'Staffel nicht gefunden',
  episodeNotFound: 'Folge nicht gefunden',
  rubriqueNotFound: 'Rubrik nicht gefunden',

  // Video player

  loadingVideo: 'Video wird geladen...',
  loadingPlayer: 'Player wird geladen...',
  loadingEpisodes: 'Episoden werden geladen...',

  // Badges and labels
  min: 'Min',
  enemiesToLovers: 'Feinde werden Liebhaber',

  // Actions
  cancel: 'Abbrechen',
  delete: 'Löschen',
  remove: 'Entfernen',
  removeFromList: 'Aus „Meine Liste“ entfernen',
  subscribe: 'Abonnieren',
  selectLanguage: 'Sprache auswählen',
  restartRequired: 'Neustart erforderlich',
  restartMessage: 'Bitte starten Sie die App neu, um die neue Textrichtung anzuwenden.',
  restartToApplyLanguage: 'App neu starten, um die neue Sprache anzuwenden?',
  ok: 'OK',
  save: 'Speichern',
  saving: 'Wird gespeichert...',
  editProfile: 'Profil bearbeiten',
  pseudo: 'Pseudonym',
  enterPseudo: 'Pseudonym eingeben',
  pseudoPlaceholder: 'Wählen Sie einen eindeutigen Namen (max. 16 Zeichen)',
  pseudoTaken: 'Dieses Pseudonym ist bereits vergeben',
  pseudoInvalid: 'Dieses Pseudonym enthält unangemessene Inhalte',
  pseudoInvalidCharacters: 'Dieses Pseudonym enthält ungültige Zeichen',
  pseudoNotAccepted: 'Bitte wählen Sie ein anderes Pseudonym, dieses kann nicht akzeptiert werden',
  pseudoMaxLength: 'Pseudonym darf maximal 16 Zeichen haben',
  pseudoCharactersCount: '{{count}}/16 Zeichen',
  editPseudo: 'Pseudonym bearbeiten',
  pseudoUpdated: 'Pseudonym erfolgreich aktualisiert',
  subtitles: 'Untertitel',
  off: 'Aus',
  noSubtitlesAvailable: 'Keine Untertitel verfügbar',
  playbackSpeed: 'Wiedergabegeschwindigkeit',
  normalSpeed: 'Normal',
  profileInformation: 'Profilinformationen',
  dateOfBirth: 'Geburtsdatum',
  phoneNumber: 'Telefonnummer',
  enterPhoneNumber: 'Telefonnummer eingeben',
  notProvided: 'Nicht angegeben',
  dateFormatHint: 'Format: {format} (z. B. {example})',
  dateFormatPattern: 'TT.MM.JJJJ',
  dateFormatExample: '31.12.1990',
  invalidDateFormat: 'Bitte verwenden Sie das Format: {format}',
  invalidDate: 'Ungültiges Datum',

  // Placeholders and descriptions
  discoverGenre: 'Entdecken',

  // Time and duration
  m: 'Mio.',
  now: 'jetzt',
  minuteAbbrev: 'Min',
  hourAbbrev: 'Std',
  dayAbbrev: 'T',
  monthAbbrev: 'Mon',

  // History and viewing progress
  noViewingHistory: 'Kein Wiedergabeverlauf',
  episodesWillAppearHere: 'Folgen, die Sie ansehen, erscheinen hier',
  history: 'Verlauf',
  series: 'Serien',
  noFavoritesYet: 'Noch keine Favoriten',
  addContentToFavorites: 'Fügen Sie Serien und Folgen zu Ihren Favoriten hinzu, um sie hier zu sehen',

  // My Purchases
  myPurchases: 'Meine Käufe',
  purchased: 'Gekauft',
  myPurchasesTitle: 'Ihre freigeschalteten Folgen',
  myPurchasesDescription: 'Finden Sie hier alle Premium-Folgen, die Sie mit Ihren Münzen freigeschaltet haben. Schauen Sie weiter, um mehr Münzen zu verdienen!',
  tutorialStep1Title: 'Folgen ansehen',
  tutorialStep1Description: 'Verdienen Sie Münzen, indem Sie kostenlose Inhalte auf der Plattform ansehen.',
  tutorialStep2Title: 'Belohnungen sammeln',
  tutorialStep2Description: 'Schließen Sie Herausforderungen ab und melden Sie sich täglich an, um noch mehr Münzen zu verdienen.',
  tutorialStep3Title: 'Premium-Inhalte freischalten',
  tutorialStep3Description: 'Verwenden Sie Ihre Münzen, um exklusive Premium-Folgen freizuschalten.',
  goToRewards: 'Zu den Belohnungen',

  // Gamification notifications
  userSignupNotification: 'Willkommen! Sie haben {coins} Münzen für die Erstellung Ihres Kontos erhalten!',
  dailyVisitNotification: 'Sie haben {coins} Münzen für Ihren täglichen Besuch erhalten!',
  emailProvidedNotification: 'Sie haben {coins} Münzen für die Angabe Ihrer E-Mail erhalten!',
  msisdnProvidedNotification: 'Sie haben {coins} Münzen für die Angabe Ihrer Telefonnummer erhalten!',
  birthDateProvidedNotification: 'Sie haben {coins} Münzen für die Angabe Ihres Geburtsdatums erhalten!',
  completeProfileNotification: 'Sie haben {coins} Münzen für das Ausfüllen Ihres Profils erhalten!',
  pseudoProvidedNotification: 'Sie haben {coins} Münzen für die Erstellung eines benutzerdefinierten Pseudonyms erhalten!',
  selectImageSource: 'Bildquelle auswählen',
  takePhoto: 'Foto aufnehmen',
  chooseFromLibrary: 'Aus Bibliothek auswählen',
  removeProfilePicture: 'Profilbild entfernen',
  removeProfilePictureConfirm: 'Möchten Sie Ihr Profilbild wirklich entfernen?',
  profilePictureUpdated: 'Profilbild erfolgreich aktualisiert',
  profilePictureRemoved: 'Profilbild erfolgreich entfernt',
  failedToPickImage: 'Bild konnte nicht aus der Bibliothek ausgewählt werden',
  failedToTakePhoto: 'Foto konnte nicht aufgenommen werden',
  failedToUploadImage: 'Bild-Upload fehlgeschlagen. Bitte erneut versuchen.',
  imageInappropriateContent: 'Bild enthält unangemessene Inhalte',
  failedToUpdateProfilePicture: 'Profilbild konnte nicht aktualisiert werden',
  failedToRemoveProfilePicture: 'Profilbild konnte nicht entfernt werden',
  watchEpisodeNotification: 'Sie haben {coins} Münzen für das Ansehen einer Folge erhalten!',
  watchAdsNotification: 'Sie haben {coins} Münzen für das Ansehen von Werbung erhalten!',
  enableNotificationsNotification: 'Sie haben {coins} Münzen für das Aktivieren von Benachrichtigungen erhalten!',
  followSocialNotification: 'Sie haben {coins} Münzen dafür erhalten, dass Sie uns in sozialen Medien folgen!',
  coinsEarnedNotification: 'Sie haben {coins} Münzen erhalten!',
  coinsUsedForPremiumNotification: 'Sie haben {coins} Münzen verwendet, um diese Premium-Folge freizuschalten!',
  firstCoinsUsageNotification: 'Willkommen! Sie haben gerade Ihre erste Premium-Folge mit Münzen freigeschaltet!',

  // Reward Center
  rewardCenter: 'Belohnungszentrum',
  rewards: 'Belohnungen',
  weeklyRanking: 'Wöchentliche Rangliste',
  hallOfFame: 'Ruhmeshalle',
  thisWeeksTopPlayers: 'Die Top-Spieler dieser Woche',
  allTimeChampions: 'Allzeit-Champions',
  totalCoinsAllTime: 'Münzen insgesamt',
  coinsThisWeek: 'Münzen diese Woche',
  achievements: 'Erfolge',
  dayStreakRecord: 'Tage-Serie',
  you: 'Du',
  noRankingData: 'Keine Ranglistendaten verfügbar',
  checkBackLaterRanking: 'Schauen Sie später für wöchentliche Ranglisten vorbei',
  noHallOfFameData: 'Keine Ruhmeshalle-Daten verfügbar',
  checkBackLaterHallOfFame: 'Schauen Sie später für Allzeit-Ranglisten vorbei',
  coins: 'Münzen',
  days: 'Tage',
  dailyCheckIn: 'Täglicher Check-in',
  earnRewards: 'Belohnungen verdienen',
  completed: 'Abgeschlossen',
  claim: 'Zu erledigen',
  comingSoon: 'Demnächst',
  day: 'Tag',
  today: 'Morgen',
  totalCoins: 'Münzen insgesamt',
  getCoins: 'Münzen sammeln,',
  keepWatching: 'Weiter schauen',
  dayStreak: 'Tage-Serie',
  nextReward: 'Nächste Belohnung',
  availableTomorrow: 'Morgen verfügbar',
  weekProgress: 'Wochenfortschritt',
  serie: 'Serie',
  won: 'Gewonnen',
  tomorrow: 'Morgen',
  toDo: 'Zu erledigen',
  firstWeek: 'Erste Woche',
  secondWeek: 'Zweite Woche',
  amazingStreak: 'Tolle Serie! Weiter so!',
  overallProgress: 'Gesamtfortschritt',
  of: 'von',
  eventsCompleted: 'Events abgeschlossen',
  ofMissionsCompleted: 'der Missionen abgeschlossen',

  // Gamification event categories
  gamificationCategoryUser: 'Benutzer',
  gamificationCategoryProfile: 'Profil',
  gamificationCategoryContent: 'Inhalt',
  gamificationCategoryGeneral: 'Allgemein',
  gamificationCategoryDailyMission: 'Tägliche Mission',
  gamificationCategoryWelcomeMissions: 'Willkommensmissionen',
  gamificationCategoryWatchMissions: 'Schau-Missionen',
  gamificationCategoryOnceAYear: 'Einmal im Jahr',

  // Gamification Intro Modal (for guests)
  gamificationIntroSubtitle: 'Schließen Sie Missionen ab und verdienen Sie Münzen!',
  gamificationFeature1Title: 'Konto erstellen',
  gamificationFeature1Desc: 'Erhalten Sie {{coins}} Willkommensmünzen bei der Registrierung',
  gamificationFeature2Title: 'Folgen ansehen',
  gamificationFeature2Desc: 'Verdienen Sie {{coins}} Münzen für jede abgeschlossene Folge',
  gamificationFeature3Title: 'In der Rangliste aufsteigen',
  gamificationFeature3Desc: 'Vergleichen Sie sich jede Woche mit anderen Mitgliedern',
  gamificationFeature4Title: 'Premium-Folgen freischalten',
  gamificationFeature4Desc: 'Verwenden Sie Ihre Münzen, um noch mehr Folgen zu sehen',
  gamificationBonusText: '+{{coins}} Münzen gratis bei der Registrierung!',
  createAccount: 'Konto erstellen',
  connectToYou: 'Anmelden',

  // All Episodes Control
  allEpisodes: 'Alle Folgen',
  watchNow: 'Jetzt ansehen',
  previousEpisode: 'Vorherige',
  nextEpisode: 'Nächste',

  // App availability
  appNotAvailable: 'Diese Anwendung ist in Ihrem Land und Ihrer Sprache noch nicht verfügbar.',
  appNotAvailableSubtext: 'Wir arbeiten daran, unseren Service auf weitere Regionen auszuweiten.',

  // Biometric authentication
  biometricLogin: 'Biometrische Anmeldung',
  signInWithBiometric: 'Mit Biometrie anmelden',
  signInWithWebAuthn: 'Mit WebAuthn anmelden',
  signInWithFaceId: 'Mit Face ID anmelden',
  signInWithTouchId: 'Mit Touch ID anmelden',
  enableBiometric: 'Biometrische Anmeldung aktivieren',
  disableBiometric: 'Biometrische Anmeldung deaktivieren',
  biometricNotAvailable: 'Biometrische Authentifizierung ist auf diesem Gerät nicht verfügbar',
  biometricAuthFailed: 'Biometrische Authentifizierung fehlgeschlagen',
  biometricDataMissing: 'Daten zur biometrischen Anmeldung fehlen. Bitte melden Sie sich mit OTP an und aktivieren Sie die biometrische Anmeldung erneut in Ihren Profileinstellungen.',
  biometricNoUserData: 'Bitte melden Sie sich zuerst an und aktivieren Sie dann die biometrische Anmeldung in Ihren Profileinstellungen.',
  biometricUnexpectedError: 'Ein unerwarteter Fehler ist aufgetreten. Bitte melden Sie sich mit OTP an und aktivieren Sie die biometrische Anmeldung erneut in Ihren Profileinstellungen.',
  biometricAuthCancelled: 'Biometrische Authentifizierung wurde abgebrochen. Bitte erneut versuchen.',
  webauthnNotEnabled: 'Bitte melden Sie sich zuerst an und aktivieren Sie dann die WebAuthn-Anmeldung in Ihren Profileinstellungen.',
  webauthnCancelled: 'WebAuthn-Authentifizierung wurde abgebrochen. Bitte erneut versuchen.',
  webauthnFailed: 'WebAuthn-Authentifizierung fehlgeschlagen',
  biometricLoginEnabled: 'Biometrische Anmeldung wurde aktiviert',
  biometricLoginDisabled: 'Biometrische Anmeldung wurde deaktiviert',
  webauthnLoginEnabled: 'WebAuthn-Anmeldung wurde aktiviert',
  webauthnLoginDisabled: 'WebAuthn-Anmeldung wurde deaktiviert',
  faceIdLoginEnabled: 'Face ID-Anmeldung wurde aktiviert',
  faceIdLoginDisabled: 'Face ID-Anmeldung wurde deaktiviert',
  touchIdLoginEnabled: 'Touch ID-Anmeldung wurde aktiviert',
  touchIdLoginDisabled: 'Touch ID-Anmeldung wurde deaktiviert',
  androidBiometricLoginEnabled: 'Biometrische Anmeldung wurde aktiviert',
  androidBiometricLoginDisabled: 'Biometrische Anmeldung wurde deaktiviert',
  failedToEnableBiometric: 'Biometrische Anmeldung konnte nicht aktiviert werden',
  failedToDisableBiometric: 'Biometrische Anmeldung konnte nicht deaktiviert werden',
  failedToEnableWebauthn: 'WebAuthn-Anmeldung konnte nicht aktiviert werden',
  failedToDisableWebauthn: 'WebAuthn-Anmeldung konnte nicht deaktiviert werden',
  success: 'Erfolg',
  enableBiometricPrompt: 'Biometrische Authentifizierung für die schnelle Anmeldung beim nächsten Mal aktivieren?',
  enableBiometricPromptIos: '{authType} für die schnelle Anmeldung beim nächsten Mal aktivieren?',
  'Enable {{authType}}?': '{{authType}} aktivieren?',
  'Would you like to enable {{authType}} for faster login?': 'Möchten Sie {{authType}} für eine schnellere Anmeldung aktivieren?',
  '{{authType}} login has been enabled!': '{{authType}}-Anmeldung wurde aktiviert!',
  'Failed to enable {{authType}} login. Please try again later.': '{{authType}}-Anmeldung konnte nicht aktiviert werden. Bitte später erneut versuchen.',
  biometricLoginTitle: 'Biometrische Anmeldung',
  faceIdLogin: 'Face ID-Anmeldung',
  touchIdLogin: 'Touch ID-Anmeldung',
  useBiometricToSignIn: 'Verwenden Sie Fingerabdruck oder Gesichtserkennung für eine schnelle Anmeldung',
  enableBiometricForSignIn: 'Aktivieren Sie Fingerabdruck oder Gesichtserkennung für die schnelle Anmeldung',
  useFaceIdToSignIn: 'Verwenden Sie Face ID für eine schnelle Anmeldung',
  enableFaceIdForSignIn: 'Aktivieren Sie Face ID für die schnelle Anmeldung',
  useTouchIdToSignIn: 'Verwenden Sie Touch ID für eine schnelle Anmeldung',
  enableTouchIdForSignIn: 'Aktivieren Sie Touch ID für die schnelle Anmeldung',

  // Delete account
  deleteMyAccount: 'Mein Konto löschen',
  deleteAccountConfirmation: 'Löschbestätigung',
  deleteAccountWarningNotSubscribed: 'Wir werden mit der Löschung Ihres Kontos fortfahren. Nach der Bestätigung können Sie nicht mehr auf Hekaya zugreifen.\n\nBitte beachten Sie, dass wir gemäß den Vorschriften bestimmte Daten sicher aufbewahren, beispielsweise zur möglichen Streitbeilegung.',
  deleteAccountWarningSubscribed: 'Sie haben derzeit ein aktives Abonnement. Bitte kündigen Sie es zuerst. Die Anleitung zur Kündigung finden Sie unter „Mein Konto“, „Abbestellen“. Sobald das Abonnement gekündigt ist, können Sie mit der Löschung Ihres Kontos fortfahren.\n\nWir werden mit der Löschung Ihres Kontos fortfahren. Nach der Bestätigung können Sie nicht mehr auf Hekaya zugreifen.\n\nBitte beachten Sie, dass wir gemäß den Vorschriften bestimmte Daten sicher aufbewahren, beispielsweise zur möglichen Streitbeilegung.',
  iConfirm: 'Ich bestätige',
  deletingAccount: 'Konto wird gelöscht...',
  accountDeleted: 'Konto gelöscht',
  accountDeletedSuccess: 'Ihr Konto wurde erfolgreich gelöscht',
  accountDeleteError: 'Fehler beim Löschen des Kontos',
  activeSubscriptionErrorTitle: 'Aktives Abonnement',
  activeSubscriptionErrorMessage: 'Sie müssen Ihr Abonnement kündigen, bevor Sie Ihr Konto löschen können.',
  gracePeriodErrorTitle: 'Löschung noch nicht möglich',
  gracePeriodErrorMessage: 'Ihr Abonnement wurde gekündigt, bleibt aber bis zu seinem Ablaufdatum aktiv. Sie können Ihr Konto nach Ablauf dieses Zeitraums löschen.',
  gracePeriodBannerTitle: 'Abonnement gekündigt',
  gracePeriodBannerMessage: 'Ihr Abonnement wurde gekündigt, bleibt aber bis zum {{date}} aktiv. Bis dahin haben Sie weiterhin Zugriff auf alle Premium-Inhalte.',
  notBilledDenyBannerTitle: 'Abonnement gesperrt',
  notBilledDenyBannerMessage: 'Ihr Abonnement wurde aufgrund eines Zahlungsproblems vorübergehend gesperrt. Um den Zugang zu unserem Dienst wiederherzustellen, laden Sie bitte Ihr Konto *9 auf. Ihr Hekaya-Konto wird reaktiviert, sobald die Zahlung verarbeitet wurde.',

  // Network connection
  noInternetConnection: 'Keine Internetverbindung verfügbar. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  noInternetConnectionShort: 'Keine Internetverbindung',
  checkInternetConnection: 'Bitte überprüfen Sie Ihre Internetverbindung',
  connectionRequired: 'Internetverbindung erforderlich',
  dismiss: 'Offline fortfahren',
  slowNetworkDetected: 'Langsames Netzwerk erkannt',
  poorNetworkConnection: 'Ihre Netzwerkverbindung hat Probleme. Das Laden von Videos dauert länger als gewöhnlich.',
  loadingTime: 'Ladezeit',
  slowConnection: 'Langsame Verbindung',

  // App version
  version: 'Version',

  // Image cache
  imageCacheStorage: 'Bild-Cache-Speicher',
  cachedImages: 'Zwischengespeicherte Bilder',
  storageUsed: 'Verwendeter Speicher',
  expiredImages: 'Abgelaufene Bilder',
  clearExpiredCache: 'Abgelaufene löschen',
  clearAllCache: 'Alle löschen',
  clearing: 'Wird gelöscht...',
  clearImageCache: 'Bild-Cache leeren',
  clearImageCacheConfirmation: 'Möchten Sie wirklich alle zwischengespeicherten Bilder löschen? Dadurch wird Speicherplatz freigegeben, aber die Bilder müssen erneut heruntergeladen werden.',
  clearCache: 'Cache leeren',
  cacheCleared: 'Cache erfolgreich geleert! {{count}} Bilder gelöscht.',
  expiredCacheCleared: 'Abgelaufener Cache geleert! {{count}} abgelaufene Bilder entfernt.',
  noExpiredCache: 'Keine abgelaufenen Bilder zum Löschen.',
  failedToClearCache: 'Cache konnte nicht geleert werden. Bitte erneut versuchen.',
  cacheAutoClears30Days: 'Bilder werden nach 30 Tagen automatisch gelöscht',
  info: 'Info',

  // Pagination
  scrollForMore: 'Für mehr scrollen',
  noMoreContent: 'Ende der Liste',
  loadingMore: 'Wird geladen...',

  // OTP Authentication
  otp: {
    signInOrSignUp: 'Anmelden oder kostenloses Konto erstellen',
    subscriptionWelcomeTitle: 'Vielen Dank für Ihr Abonnement!',
    subscriptionWelcomeMessage: 'Letzter Schritt: Registrieren Sie sich, um ein Konto zu erstellen, oder melden Sie sich bei einem bestehenden Konto an, um Dramen anzusehen.',
    emailPlaceholder: 'E-Mail-Adresse',
    phonePlaceholder: 'Telefonnummer',
    emailOrPhonePlaceholder: 'E-Mail oder Telefonnummer',
    continue: 'Weiter',
    continueWithGoogle: 'Mit Google fortfahren',
    continueWithApple: 'Mit Apple fortfahren',
    termsPrefix: 'Indem Sie fortfahren, akzeptieren Sie unsere',
    termsOfService: 'Nutzungsbedingungen',
    privacyPolicy: 'Datenschutzerklärung',
    confirmEmail: 'E-Mail-Adresse bestätigen',
    confirmYourEmail: 'Bestätigen Sie Ihre E-Mail-Adresse',
    confirmPhone: 'Telefonnummer bestätigen',
    confirmYourPhone: 'Bestätigen Sie Ihre Telefonnummer',
    codeSentTo: 'Wir haben einen Code gesendet an',
    codeSentToPhone: 'Wir haben einen Code gesendet an',
    enterCodeBelow: 'Geben Sie ihn unten ein, um Ihr Konto zu bestätigen.',
    resendCode: 'Code erneut senden',
    resendIn: 'Erneut senden in',
    verify: 'Bestätigen',
    connectingInProgress: 'Verbindung wird hergestellt...',
    accountCreated: 'Konto erstellt',
    stayUpdatedTitle: 'Möchten Sie über die neuesten Nachrichten informiert bleiben?',
    stayUpdatedDescription: 'Wir würden Ihnen gerne personalisierte Angebote, inspirierende Inhalte, Gerätetipps und Informationen zu unseren neuesten Innovationen senden.',
    learnMore: 'Mehr erfahren',
    subscribe: 'Abonnieren',
    noThanks: 'Nein, danke',
    enterEmailOrPhone: 'Bitte geben Sie Ihre E-Mail oder Telefonnummer ein',
    sendFailed: 'Code konnte nicht gesendet werden. Bitte erneut versuchen.',
    enterCompleteCode: 'Bitte geben Sie den vollständigen 6-stelligen Code ein',
    verificationFailed: 'Überprüfung fehlgeschlagen. Bitte erneut versuchen.',
    invalidCode: 'Ungültiger Code. Bitte erneut versuchen.',
    codeExpired: 'Code ist abgelaufen. Bitte fordern Sie einen neuen an.',
    checkSpamFolder: 'Denken Sie daran, Ihren Spam-Ordner zu überprüfen',
    dcbValidatingSubscription: 'Ihr Abonnement wird validiert...',
    dcbActivating: 'Ihr Abonnement wird aktiviert...',
    dcbSuccessTitle: 'Abonnement aktiviert!',
    dcbSuccessMessage: 'Ihr Abonnement wurde erfolgreich aktiviert. Sie können jetzt alle Inhalte genießen.',
    dcbStartWatching: 'Mit dem Ansehen beginnen',
    dcbErrorTitle: 'Aktivierungsfehler',
    dcbErrorRetry: 'Bei der Aktivierung Ihres Abonnements ist ein Fehler aufgetreten. Bitte erneut versuchen.',
    dcbPaymentNotFound: 'Abonnement nicht gefunden. Bitte überprüfen Sie Ihren Link oder wenden Sie sich an den Support.',
    dcbRetryButton: 'Erneut versuchen',
    dcbIdentityMismatchPhone: 'Die für das Abonnement verwendete Telefonnummer ist {{identifier}}. Bitte verwenden Sie diese Nummer, um Ihr Konto zu erstellen.',
    dcbIdentityMismatchEmail: 'Die für das Abonnement verwendete E-Mail ist {{identifier}}. Bitte verwenden Sie diese E-Mail, um Ihr Konto zu erstellen.',
    dcbRecoveryBanner: 'Ein ausstehendes Abonnement wurde erkannt. Erstellen Sie Ihr Konto, um darauf zuzugreifen.',
    dcbAlreadySubscribed: 'Bereits über Mobilzahlung abonniert?',
    dcbEnterPhone: 'Geben Sie die bei der Zahlung verwendete Telefonnummer ein:',
    dcbRecoverButton: 'Wiederherstellen',
    dcbMsisdnNotFound: 'Kein ausstehendes Abonnement für diese Nummer gefunden.',
    dcbMsisdnRecoveryFailed: 'Wiederherstellung fehlgeschlagen. Bitte erneut versuchen.',
    invalidPhoneNumber: 'Ungültige Telefonnummer.',
  },
  and: 'und',
  smartBannerSubtitle: 'Bessere Erfahrung in der App',
  smartBannerOpen: 'ÖFFNEN',
  paymentVerifying: 'Ihr Abonnement wird überprüft...',
  paymentSuccessTitle: 'Abonnement aktiviert!',
  paymentSuccessMessage: 'Herzlichen Glückwunsch, Sie haben jetzt Zugriff auf alle Premium-Inhalte.',
  paymentSuccessButton: 'Mit dem Ansehen beginnen',
  paymentPendingMessage: 'Ihre Zahlung ist eingegangen. Ihr Abonnement wird in Kürze aktiv sein.',
  paymentRefreshButton: 'Aktualisieren',
  redirectingToPayment: 'Weiterleitung zur Zahlungsseite...',
  webPaymentIframeErrorTitle: 'Zahlungsseite nicht verfügbar',
  webPaymentIframeErrorMessage: 'Die Zahlungsseite konnte in der App nicht geladen werden. Sie können sie in einem neuen Tab öffnen.',
  webPaymentOpenExternal: 'In neuem Tab öffnen',

  // Premium subscription card
  enterPremiumExperience: 'Betreten Sie die',
  mobileInvoice: 'Handyrechnung',
  mobileInvoicePrice: '9,99 €/Monat',
  mobileInvoiceDescription: 'Zahlung auf Ihrer Handyrechnung. Einfach und schnell.',
  cardAppleGooglePay: 'Karte / Apple Pay / Google Pay',
  cardPaymentDescription: 'Sichere Zahlung per Karte, Apple Pay oder Google Pay.',
  dcbPaymentOfferDescription: 'Zahlung uber Ihre Telefonrechnung. Einfach und schnell.',
  appStorePaymentTitle: 'App Store',
  appStorePaymentDescription: 'Abonnement wird über Ihr Apple App Store Konto abgerechnet und verwaltet.',
  playStorePaymentTitle: 'Google Play',
  playStorePaymentDescription: 'Abonnement wird über Ihr Google Play Store Konto abgerechnet und verwaltet.',
  upgradeToPremium: 'Auf Premium upgraden',
  cancelAnytimeNoCommitment: 'Jederzeit kündbar · Keine Verpflichtung',
  whyBecomeVip: 'Warum VIP werden?',
  joinPremiumCommunity: 'Treten Sie unserer Premium Hekaya-Community bei',
  unlimitedAccessShort: 'Zugriff auf alle Serien und Folgen ohne Limits.\nSehen Sie, wann und wo Sie wollen.',

  // DCB subscription details (profile view)
  dcbOfferDaily: 'Tägliches Abonnement',
  dcbOfferWeekly: 'Wöchentliches Abonnement',
  dcbOfferMonthly: 'Monatliches Abonnement',
  dcbOfferQuarterly: 'Vierteljährliches Abonnement',
  dcbOfferYearly: 'Jährliches Abonnement',
  dcbOfferRecurring: 'Wiederkehrendes Abonnement',
  dcbSubscriptionValidity: 'Gültig bis {{date}}',
};

export type TranslationKey = keyof typeof de;
